import { FC, useLayoutEffect, useState } from "react";
import { Router } from "react-router-dom";
import history from "../../utils/history";

const BrowserRouterWithHistory: FC = ({ children }) => {
  let [state, setState] = useState({
    action: history.action,
    location: history.location,
  });
  useLayoutEffect(() => history.listen(setState), []);

  return (
    <Router
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
};

export default BrowserRouterWithHistory;
